module.exports = __webpack_public_path__ + "img/vuetify.0fbd13fd.png";